import loadable from "@loadable/component";
import APIS from "../../constant/EndPoint";
import CreateIcon from "../../Icons/CreateIcon";
import usePostHook from "../../customHooks/usePostHook";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const CreateRiderComponent = loadable(
  () => import("../../components/Rider/CreateRider")
);
const CreateRider = () => {
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["riders"],
    navigateURL: "/rider",
  });

  const handleCreate = async (values: any, setError: any) => {
    const url = `${APIS.DRIVER}`;
    let formData = {
      ...values,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Create Rider
        </span>
      </div>
      <CreateRiderComponent
        isLoading={isPostLoading}
        handleCreate={handleCreate}
      />
    </>
  );
};

export default CreateRider;
